import React, { useState } from "react";

import { actions } from "../../actions";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Empty, Card,Tooltip, Statistic} from "antd";
import workflow from "../../assets/landingFeatures/workflow.jpg";
import explorer from "../../assets/landingFeatures/explorer.png";
import vendor from "../../assets/landingFeatures/vendorconnect.png";
import qhrflow from "../../assets/landingFeatures/qhrFlow.png";

import {
  ApartmentOutlined,
  CheckSquareOutlined,
  RobotOutlined,
  MessageOutlined,
  FormOutlined,
  BarChartOutlined,
  CalendarOutlined,
  TeamOutlined,
  FileSearchOutlined,
  DeploymentUnitOutlined, 
  SearchOutlined,
  AppstoreOutlined,
  IdcardOutlined,
  BellOutlined,
  CloudUploadOutlined, 
  ClockCircleOutlined,
  EnvironmentOutlined, 
  SmileOutlined,
  ReconciliationOutlined ,
  DatabaseOutlined,
} from "@ant-design/icons";

import "./features.css";

function Features(props) {
  const [loader, SetLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleSubmit } = props;
  const { Meta } = Card;

  const contentStyle = {
    padding: "5px",
    height: "300px",
    width: "auto",
    background: "#eff6ff",
    border: "1px solid #dbeafe",
  };

  const contentStyleJobListing = {
    padding: "5px",
    height: "300px",
    width: "auto",
    background: "#eff6ff",
    border: "1px solid #dbeafe",
  };

  const contentStyleERL = {
    padding: "5px",
    height: "250px",
    width: "auto",
    background: "#eff6ff",
    border: "1px solid #dbeafe",
  };
  const onSubmit = () => {
    let dataToSend = { email: email };
    let inputData = { email: email };
    SetLoader(true);

    dispatch(
      actions.SignIn(dataToSend, (error, status) => {
        if (!error) {
          navigate("/otp", { state: { inputData, type: "login" } });
          SetLoader(false);
        } else {
          // Handle the error case
          SetLoader(false);
          console.error("API Error:", error);
          let e = error.split("or");
          setError(e[0] + "signup first");
          // setErrorMessage(error); // Set the error message in state
        }
      })
    );
  };

  const handleSignin = () => {
    navigate("/login");
  };

  const handleSignup = () => {
    navigate("/signup");
  };

  
  const handleJobSeekers = () => {
    navigate("/nujobs");
  };
  const handleClick = () => {};

  const coreFeatures = [
    {
      icon: <ApartmentOutlined />,
      label: "Workflow Automation",
      color: "#5264cd",
      tooltip: "Automate and streamline your recruitment workflows",
    },
    {
      icon: <CheckSquareOutlined />,
      label: "Task Management",
      color: "#5264cd",
      tooltip: "Manage Teams productivity and tasks",
    },
    {
      icon: <RobotOutlined />,
      label: "AI ATS",
      color: "#5264cd",
      tooltip: "AI-powered candidate tracking and filtering",
    },
    {
      icon: <ReconciliationOutlined />,
      label: "Resume Parsing & Analysis",
      color: "#5264cd",
      tooltip: "Resume Parsing using AI based Algorithms",
    },
    {
      icon: <RobotOutlined />,
      label: "JD Creation",
      color: "#5264cd",
      tooltip: "Create JDs using our AI based Algorithm",
    },
    {
      icon: <MessageOutlined />,
      label: "Messaging",
      color: "#5264cd",
      tooltip: "Reach multiple candidates instantly with automated messaging",
    },
    {
      icon: <FormOutlined />,
      label: "Forms",
      color: "#5264cd",
      tooltip: "Send forms and centralize responses",
    },
    {
      icon: <BarChartOutlined />,
      label: "Evaluations",
      color: "#5264cd",
      tooltip: "Evaluate multiple candidates efficiently",
    },
    {
      icon: <CalendarOutlined />,
      label: "Interview Management",
      color: "#5264cd",
      tooltip: "Interview Scheduling and Reminders",
    },
    {
      icon: <BarChartOutlined  />,
      label: "Data Analytics",
      color: "#5264cd",
      tooltip: "Interview Scheduling and Reminders",
    },
    {
      icon: <SearchOutlined  />,
      label: "Search Database",
      color: "#5264cd",
      tooltip: "Interview Scheduling and Reminders",
    }, 
    {
      icon: <ReconciliationOutlined   />,
      label: "Resume Search Automation",
      color: "#5264cd",
      tooltip: "Interview Scheduling and Reminders",
    },            
  ];  

  const stats = [
    { title: "Companies", value: 10 },
    { title: "Recruiters", value: 20 },
    { title: "Resumes", value: 9000 },
    { title: "Forms", value: 2000 },
    { title: "Evaluations", value: 500 },
  ];

  const jobStats = [
    { title: "Companies", value: 10 },
    { title: "Candidates", value: 10000 },
    { title: "Jobs", value: 900 },
  ];
  const erlStats = [
    { title: "Companies", value: 5 },
    { title: "Employees", value: 2000 },
  ];
  const erlFeatures = [
  {
    icon: <ClockCircleOutlined />,
    title: "Employee Timesheet",
    subtitle: "Track work hours",
    desc: "Capture daily, monthly, and yearly login/logout activity.",
    color: "#3e5615",
  },
  {
    icon: <CalendarOutlined />,
    title: "Leave Management",
    subtitle: "Simplify requests",
    desc: "Manage employee leaves without complex payroll systems.",
    color: "#3e5615",
  },
  {
    icon: <TeamOutlined />,
    title: "Holiday Management",
    subtitle: "Custom calendars",
    desc: "Create and manage organization-specific holiday lists.",
    color: "#3e5615",
  },
  {
    icon: <EnvironmentOutlined />,
    title: "Geo Tagging",
    subtitle: "Location tracking",
    desc: "Enable geolocation-based attendance and verification.",
    color: "#3e5615",
  },
];

  const whyHire2 = [
  {
    icon: <AppstoreOutlined />,
    title: "All-in-One Platform",
    desc: "Replace ATS, vendor tools, job portals, and HR systems with a single integrated solution.",
  },
  {
    icon: <RobotOutlined />,
    title: "AI-Driven Hiring",
    desc: "Automate candidate screening, evaluation, and workflows using intelligent automation.",
  },
  {
    icon: <ClockCircleOutlined />,
    title: "Faster Time-to-Hire",
    desc: "Reduce manual effort and accelerate hiring cycles with streamlined workflows.",
  },
  {
    icon: <DeploymentUnitOutlined />,
    title: "Built for Scale",
    desc: "Designed to handle high-volume hiring, multiple vendors, and growing teams.",
  },
  {
    icon: <ApartmentOutlined />,
    title: "Seamless Integration",
    desc: "Works across your hiring ecosystem — from sourcing to onboarding.",
  },
  {
    icon: <SmileOutlined />,
    title: "Better Candidate Experience",
    desc: "Faster communication, structured processes, and a modern job platform.",
  },
];

  const nuJobFeatures = [
        {
          icon: <CloudUploadOutlined />,
          label: "Post & Apply",
          color: "#3498db",
          tooltip: "Publish jobs and apply seamlessly",
        },
        {
          icon: <AppstoreOutlined />,
          label: "Categories",
          color: "#3498db",
          tooltip: "Browse jobs across industries",
        },
        {
          icon: <SearchOutlined />,
          label: "ATS Ready",
          color: "#3498db",
          tooltip: "Works with or without QHRFlow ATS",
        },
        {
          icon: <IdcardOutlined />,
          label: "Profile",
          color: "#3498db",
          tooltip: "Create and manage your profile",
        },
        {
          icon: <BellOutlined />,
          label: "Alerts",
          color: "#3498db",
          tooltip: "Get notified about jobs instantly",
        },
      ];
      const vendorFeatures = [
        {
          icon: <TeamOutlined />,
          title: "Vendor Management",
          desc: "Manage all recruitment vendors from a single dashboard.",
          color: "#5264cd",
        },
        {
          icon: <FileSearchOutlined />,
          title: "Resume Quality Analysis",
          desc: "Automatically evaluate and rank candidates.",
          color: "#5264cd",
        },
        {
          icon: <DeploymentUnitOutlined />,
          title: "Integrated ATS",
          desc: "Connect vendor submissions directly to your pipeline.",
          color: "#5264cd",
        },
      ];      
  return (
    <div className="features-wrapper">
      <div className="feature-heading">All-in-One Hiring & Workforce Platform</div>
      <div className="feature-subheading">QuallyHire ATS & WorkFlow Automation</div>
      <div className="feature-contents" style={{ color: "#464948" }}>
        <p>
          Streamline hiring, automate workflows, and scale your recruitment
          operations, reduce time-to-hire — all from a single platform.       
        </p>
      </div>

      <div className="feature-img2-wrapper">
        <div className="feature-card" style={{ background: "#b1b9e1" }}>
          QHRFlow
        </div>
        <div>
          <img
            className="feature-img2"
            src={qhrflow}
            alt="Explorer"
            width="200"
            height="200"
          />
        </div>
      </div>

      <div className="feature-carousel-wrapper">
        <div className="container">
          <div
            className="core-features-grid"
          >
            {coreFeatures.map((item, index) => (
              <Tooltip key={index} title={item.tooltip}>
                <div
                  style={{
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0px)";
                  }}
                >
                  {React.cloneElement(item.icon, {
                    style: { fontSize: 36, color: item.color, marginBottom: 10 },
                  })}
                  <div>{item.label}</div>
                </div>
              </Tooltip>
            ))}
          </div>
        </div>
      </div> 
      <div style={{
        textAlign: "center",
        marginTop: "20px"
      }}>

      </div>        
      <div
        className="feature-stats-display"
      >
          {stats.map((item, index) => (
            <div key={index}>
              <Statistic
                className="nujobs-statistic"
                title={item.title}
                value={item.value}
              />
            </div>
          ))}
      </div>                
      <div className="feature-subheading" style={{ marginTop: "5px" }}>
        Why QuallyHire?
      </div>
         
      <div className="feature-contents" style={{ maxWidth: "900px", margin: "0 auto" }}>
        A unified platform that replaces multiple hiring and workforce tools — built for speed, scale, and simplicity.
      </div>

      <div
         className="core-features-grid"
      >
        {whyHire2.map((item, index) => (
          <div
            key={index}
            style={{
              padding: "16px",
              borderRadius: "12px",
              background: "#ffffff",
              boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
              transition: "all 0.2s ease",
              cursor: "pointer",
              textAlign: "left",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-6px)";
              e.currentTarget.style.boxShadow =
                "0 12px 30px rgba(0,0,0,0.08)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0px)";
              e.currentTarget.style.boxShadow =
                "0 8px 20px rgba(0,0,0,0.05)";
            }}
          >
        {/* ICON */}
        <div style={{ marginBottom: "10px" }}>
          {React.cloneElement(item.icon, {
            style: {
              fontSize: 22,
              color: "#4f46e5", // single color
            },
          })}
        </div>

        {/* TITLE */}
        <h4
          style={{
            marginBottom: "6px",
            fontSize: "16px",
            fontWeight: 600,
            color: "#1f2937",
          }}
        >
          {item.title}
        </h4>

        {/* DESC */}
        <p
          style={{
            margin: 0,
            fontSize: "13px",
            lineHeight: "1.5",
            color: "#6b7280",
          }}
        >
          {item.desc}
        </p>
      </div>
        ))}
      </div>  
      <div
          className="core-features-grid"
      >
        <div>
          <Statistic title="Faster Hiring" value={40} suffix="%" />
          <div style={{ color: "#777" }}>Reduce time-to-hire</div>
        </div>

        <div>
          <Statistic title="Automation" value={70} suffix="%" />
          <div style={{ color: "#777" }}>Less manual work</div>
        </div>

        <div>
          <Statistic title="Candidate Reach" value={3} suffix="x" />
          <div style={{ color: "#777" }}>More candidate engagement</div>
        </div>

        <div>
          <Statistic title="Platform Consolidation" value={5} suffix="→1" />
          <div style={{ color: "#777" }}>Replace multiple tools</div>
        </div>
      </div>         
        
      <div className="feature-img2-wrapper">
        <div className="feature-card" style={{ }}>
          QHRFlow VendorConnect
        </div>
        <div>
          <img
            className="feature-img2"
            src={vendor}
            alt="Explorer"
            width="100"
            height="100"
          />
        </div>
      </div>
      <div className="feature-subheading" style={{ color: "#555758" }}>
         Vendors Login Access for QHRFlow
      </div>
      <div className="feature-contents" style={{ color: "#464948" }}>
        Centralize vendor collaboration and improve candidate quality with full pipeline visibility.
      </div>      
      <div className="feature-carousel-wrapper">
        <div className="container">
          <div
            className="core-features-grid vendor-features-grid"
          >
            {vendorFeatures.map((item, index) => (
              <Card
                key={index}
                className="features-contentStyle" 
                hoverable
                bordered
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0px)";
                }}
                cover={
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {React.cloneElement(item.icon, {
                      style: { fontSize: 40, color: item.color },
                    })}
                  </div>
                }
              >
                <Meta
                  style={{ marginTop: 10 }}
                  title={item.title}
                  description={
                    item.title === "Vendor Management"
                      ? "Centralized control"
                      : item.title === "Resume Quality Analysis"
                      ? "Smarter screening"
                      : "Seamless workflows"
                  }
                />
                <div style={{ marginTop: 10 }}>{item.desc}</div>
              </Card>
            ))}
          </div>
        </div>
      </div>         

      <div className="feature-img2-wrapper">
        <div className="feature-card" style={{ background: "#c2d1f0" }}>
           NuJobs
        </div>
        <div>
          <img
            className="feature-img3"
            src={explorer}
            alt="Explorer"
            width="auto"
            height="auto"
          />
        </div>
      </div>
      <div className="feature-subheading" style={{ color: "#555758" }}>
        Niche Jobs Platform
      </div>
      <div className="feature-contents" style={{ color: "#464948" }}>
        Whether you're a recent graduate, an experienced professional, or
        looking for a career change, we have the resources to help you succeed.
      </div>      
    
      <div className="feature-carousel-wrapper">
        <div className="container">
          <div
               className="core-features-grid"
          >
            {nuJobFeatures.map((item, index) => (
              <Tooltip key={index} title={item.tooltip}>
                <div
                  style={{
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0px)";
                  }}
                >
                  {React.cloneElement(item.icon, {
                    style: { fontSize: 36, color: item.color, marginBottom: 10 },
                  })}
                  <div>{item.label}</div>
                </div>
              </Tooltip>
            ))}
            {/* empty div to balance grid if needed */}
            <div></div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" ,marginBelow: "150px" }}>
              <Button type="primary" shape="round" onClick={handleJobSeekers}>
                Explore Jobs
              </Button>
          </div>
        </div>
      </div>
      <div
          className="feature-stats-display"           
      >
          {jobStats.map((item, index) => (
            <div key={index}>
              <Statistic
                title={item.title}
                value={item.value}
                className="nujobs-statistic"
              />
            </div>
          ))}
      </div>          
      <div className="feature-img2-wrapper">
        <div className="feature-card" style={{ background: "#c2d1f0" }}>
          QuallyHire ERL
        </div>
      </div>
      <div className="feature-subheading" style={{ color: "#555758" }}>
        Employee Register and Leave Management 
      </div>
      <div className="feature-contents" style={{ color: "#464948" }}>
        Manage attendance, time tracking, and leave workflows effortlessly.
      </div>           
      <div className="feature-carousel-wrapper">
        <div className="container">
          <div
              className = "erl-features-grid"
          >
            {erlFeatures.map((item, index) => (
              <Card
                key={index}
                style={{
                  ...contentStyleERL,
                  borderRadius: "12px",
                  boxShadow: "0 6px 16px rgba(37, 99, 235, 0.08)",
                }}
                hoverable
                bordered
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0px)";
                }}
                cover={
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {React.cloneElement(item.icon, {
                      style: { fontSize: 40, color:  "#2563eb" },
                    })}
                  </div>
                }
              >
                <Meta
                  style={{ marginTop: 5 }}
                  title={item.title}
                  description={item.subtitle}
                />
                <div style={{ marginTop: 5 }}>{item.desc}</div>
              </Card>
            ))}
          </div>        
        </div>
      </div>
      <div
        style={{
          maxWidth: "1100px",
          margin: "60px auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
          gap: "30px",
          textAlign: "center",
        }}
      >
          {erlStats.map((item, index) => (
            <div key={index}>
              <Statistic
                title={item.title}
                value={item.value}
                valueStyle={{ fontWeight: 600 }}
              />
            </div>
          ))}
      </div>        
      <div className="feature-img2-wrapper">
        <div className="feature-card" style={{  }}>
          Start Hiring Smarter. Try Today
        </div>
      </div>
      <div className="feature-endHeading-wrapper">
        <div className="feature-endHeading">
          <span
            style={{
              padding: "10px",
              fontWeight: "500",
            }}
          >
            {" "}
            Quallyhire AI Product Suits
          </span>
        </div>

        <div className="feature-Button-wrapper">
          <Button type="primary" shape="round" size="large" onClick={() => navigate("/qhrflowcontact")}>
            Talk to Sales
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Features;
